import { render, staticRenderFns } from "./ViviraCodeForm.vue?vue&type=template&id=2148a028"
import script from "./ViviraCodeForm.vue?vue&type=script&lang=js"
export * from "./ViviraCodeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports